import { useQuery } from '@apollo/client';
import React from 'react';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import { PostType } from '../graphql/generated/graphql';
import verifiedIcon from '../icons/non-prefilled/16x16/verified.svg';
import UIActions from '../ui/UIActions';
import PostViewStateBar from './PostViewStateBar';
import VerifyPostModal from './VerifyPostModal';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { gql } from '../graphql/generated/gql';
import type { PostStateBarComponentProps } from './PostStateBar';

const POST_QUERY = gql(`
  query PostVerificationRequestedBar($id: ID!) {
    post(id: $id) {
      id
      type
      ...VerifyPostModal_post
    }
  }
`);

const PostVerificationRequestedBar = ({
  postId,
  compact,
}: PostStateBarComponentProps) => {
  const dispatch = useAppDispatch();
  const { data } = useQuery(POST_QUERY, { variables: { id: postId } });
  const post = data?.post;

  if (!post) return null;

  return (
    <PostViewStateBar
      actions={
        <Button
          variant="primary"
          onClick={() =>
            dispatch(UIActions.openModal(VerifyPostModal, { post }))
          }
          size="small"
        >
          Verify
        </Button>
      }
    >
      <SVGIcon>{verifiedIcon}</SVGIcon>
      <span>
        <strong>
          {post.type === PostType.Template
            ? 'Template Verification'
            : 'Verification'}
        </strong>{' '}
        requested from you.{!compact && ' Please review this post and verify.'}
      </span>
    </PostViewStateBar>
  );
};

export default PostVerificationRequestedBar;
